import { FormControl, Validators } from '@angular/forms';
import { DropDownEntry } from 'src/app/services/API.service';

export class DropdownEntryForm {
    seq = new FormControl();
    value = new FormControl();
    text = new FormControl();

    constructor(data: DropDownEntry) {
        
        if (data) {
            this.seq.setValue(data.seq);
            this.value.setValue(data.value);
            this.text.setValue(data.text);
        }

        this.seq.setValidators([Validators.required, Validators.pattern('^(0|[1-9][0-9]*)$')]);
        this.value.setValidators([Validators.required, Validators.pattern('^(0|[1-9][0-9]*)$')]);
        this.text.setValidators([Validators.required]);

    }
}